// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


export const environment: environmentClass = {
  production: true,

 // keycaptcha: "6Ld1tY0UAAAAABph2-7lYIcfflQ7SmWdMKdHHsdU", //Para ambiente de produción LFP
//  keycaptcha: "6Ld_xowUAAAAAHAoubA4SUdCP_KYx7nc5PUFXVcQ", // Clave local
 //keycaptcha: "6Lcy9_0UAAAAAGYhoEZfy4FDVi7rY7YkVOE6rpsf", // Clave pruebas
// keycaptcha: "6LfmhVccAAAAAFrhsHp6hwjnm4d-GyZ1sKyj6k3r", // Clave pruebas 02May2022
 keycaptcha: "6LdLpZwhAAAAAN3dye0ircfJL6VuiUJBUqQo-1ib", //CLAVE DIC-2022 - pruebas-local-producción
  index: "/CuentaMatriculaWeb",
  //index: "/cuenta-matricula",
  //backend: "http://localhost:8080/cuenta-matricula.back/", //Para ambiente local tener en cuenta el puerto LFP
  //backend: "http://eap7-gsisin.pruebas.intracoomeva.com.co/cuenta-matricula.back/", //Para ambiente de pruebas red interna
  backend: "https://secure.coomeva.com.co/cuenta-matricula.back/", //Para ambiente de produción LFP
  blockSubMenu: true //poner true para productivo
};
export class environmentClass {
  production: boolean = false;
  backend: string = "";
  index: string;
  keycaptcha: string;
  blockSubMenu: boolean;
}




// WEBPACK FOOTER //
// ./src/environments/environment.ts